import React, { useState }              from "react";
import { Dimensions, StyleSheet }       from "react-native";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import HomeCompactScreen                from "./src/screens/HomeCompactScreen/index.web";
import LoginScreen                      from "./src/screens/LoginScreen/index.web";
import HomeScreen                       from "./src/screens/HomeScreen/index.web";
import SplashScreen                     from "./src/screens/SplashScreen/index.web";
import LogoutScreen                     from "./src/screens/LogoutScreen/index.web";

import { AppProvider }                  from "./src/contexts/AppContext";
import { BrowserProvider }              from "./src/contexts/BrowserContext";
import { UserProvider }                 from "./src/contexts/UserContext";

export default function App() {
  const compactMode = Dimensions.get("window").width < 960;
  const [ready, setReady] = useState(false);

  return (
    <AppProvider value={{ compactMode }}>
      <UserProvider
        onReady={(isReady) => setReady(isReady)}
      >
        {!ready ? <SplashScreen visible /> : <AppRoutes />}
      </UserProvider>
    </AppProvider>
  );
}

const AppRoutes = () => {
  return (
    <BrowserProvider>
      <BrowserRouter>
        <Switch>
          <Route path="/login" component={LoginScreen} />
          <Route path="/logout" component={LogoutScreen} />
          <Route path="/compact" component={HomeCompactScreen} />
          <Route component={HomeScreen} />
        </Switch>
      </BrowserRouter>
    </BrowserProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  leftPanel: {
    maxWidth: 380,
    borderRightWidth: 1,
    borderRightColor: "lightgrey",
  },
  centerPanel: {
    minWidth: 380,
  },
  rightPanel: {
    maxWidth: 500,
    borderLeftWidth: 1,
    borderLeftColor: "lightgrey",
  },
  inner: {
    height: "100%",
  },
});
